import type { ReactElement } from 'react'
import type { BasePageProps } from '@/types'

import { Layout } from '@/components/generals/layout'
import { AppShell } from '@/components/generals/app-shell'
import { AdminShell } from '@/components/generals/admin-shell'
import { PageGate } from '@/components/generals/states'

/** Public pages: site header and footer. */
export const publicLayout = (page: ReactElement, props: BasePageProps) => (
    <Layout>
        <PageGate forbidden={props.forbidden} pageError={props.pageError}>
            {page}
        </PageGate>
    </Layout>
)

/** Signed-in candidate pages: workspace sidebar. */
export const appLayout = (page: ReactElement, props: BasePageProps) => (
    <AppShell>
        <PageGate forbidden={props.forbidden} pageError={props.pageError}>
            {page}
        </PageGate>
    </AppShell>
)

/** Admin pages: admin sidebar. */
export const adminLayout = (page: ReactElement, props: BasePageProps) => (
    <AdminShell>
        <PageGate forbidden={props.forbidden} pageError={props.pageError}>
            {page}
        </PageGate>
    </AdminShell>
)

/** Full-screen pages such as the resume builder. */
export const bareLayout = (page: ReactElement, props: BasePageProps) => (
    <PageGate forbidden={props.forbidden} pageError={props.pageError}>
        {page}
    </PageGate>
)
